import React from "react";
import JobRow from "../Job/JobRow";
import {Job as JobType} from "../Job/Job.types";

type Props = {
    jobs: JobType[]
    noJobsText: string
}

const JobsTable: React.FC<Props> = ({jobs, noJobsText}) => {
    let noJobs = true
    jobs.forEach((job) => {
        if (job.visible) {
            noJobs = false
        }
    })

    return (
        !noJobs ?
            <div className='jobs-table'>
                {jobs.map((job, index) => (
                    <JobRow key={index} job={job}/>
                ))}
            </div>
            : <div className='no-jobs'>{noJobsText}</div>
    )
}

export default JobsTable;
